import { render, staticRenderFns } from "./addCourseBoxBj.vue?vue&type=template&id=2001a6a5"
import script from "./addCourseBoxBj.vue?vue&type=script&lang=js"
export * from "./addCourseBoxBj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports